import { Chip } from "@heroui/react"
import useJobsPageStore from "../../pages/Jobs/hooks/useJobsPageStore"
import { Row } from "../Layout"
import TextLabel from "./TextLabel"

export default function TextWithRegion({ text, useLabel, showCountryIcon, isNew }: { text: string, useLabel?: boolean, showCountryIcon?: boolean, isNew?: boolean }) {
    const { selectedRegionDetails } = useJobsPageStore()

    const regionHasShortName = Boolean(selectedRegionDetails?.regionShortName)

    const countryIcon = (showCountryIcon && regionHasShortName) && (selectedRegionDetails?.imageUrl ? <img src={selectedRegionDetails.imageUrl} style={{ width: "20px" }} /> : selectedRegionDetails?.icon
    )

    if (useLabel) {
        return (
            <Row alignItems={"center"}>
                {text}
                {(regionHasShortName) && (
                    <TextLabel>{selectedRegionDetails?.regionShortName}</TextLabel>
                )}
                {countryIcon}
                {
                    isNew && <Chip color="warning">New!</Chip>
                }
            </Row>
        )
    }
    else {
        const textWithRegion = regionHasShortName ? `${text} - ${selectedRegionDetails?.regionShortName}` : text

        return (
            <Row alignItems={"center"} flexWrap={"wrap"}>
                {textWithRegion.split(' ').map((t, i) => <span key={`${t}_i`}>{t}</span>)}

                {countryIcon}

            </Row>
        )
    }

}
